/**
 * API service for Quote Approval endpoints (KAN-169).
 */

import { apiClient, APIResponse } from './client';

class QuoteApprovalService {
  private basePath = '/api/v1/quote-approvals';

  /**
   * Request quote approval for a Draft trade.
   */
  async requestApproval(
    clientId: string,
    tradeId: string
  ): Promise<APIResponse<Record<string, any>>> {
    return apiClient.post<Record<string, any>>(
      `${this.basePath}/${clientId}/trades/${tradeId}/request`
    );
  }

  /**
   * Approve a pending quote approval request.
   */
  async approveQuote(
    clientId: string,
    tradeId: string
  ): Promise<APIResponse<Record<string, any>>> {
    return apiClient.post<Record<string, any>>(
      `${this.basePath}/${clientId}/trades/${tradeId}/approve`
    );
  }

  /**
   * Reject a pending quote approval request.
   */
  async rejectQuote(
    clientId: string,
    tradeId: string,
    reason: string
  ): Promise<APIResponse<Record<string, any>>> {
    return apiClient.post<Record<string, any>>(
      `${this.basePath}/${clientId}/trades/${tradeId}/reject`,
      { reason }
    );
  }

  /**
   * Get Draft trades with pending quote approval requests.
   */
  async getPendingApprovals(
    clientId: string,
    entityIds?: string[]
  ): Promise<APIResponse<Record<string, any>[]>> {
    const params = entityIds?.length
      ? `?entity_ids=${entityIds.join(',')}`
      : '';
    return apiClient.get<Record<string, any>[]>(
      `${this.basePath}/${clientId}/pending${params}`
    );
  }

  /**
   * Get quote approval history (approved and rejected).
   */
  async getApprovalHistory(
    clientId: string,
    entityIds?: string[]
  ): Promise<APIResponse<Record<string, any>[]>> {
    const params = entityIds?.length
      ? `?entity_ids=${entityIds.join(',')}`
      : '';
    return apiClient.get<Record<string, any>[]>(
      `${this.basePath}/${clientId}/history${params}`
    );
  }
}

export const quoteApprovalService = new QuoteApprovalService();
